import React from 'react'
import styled from 'styled-components'

type DataTableHeaderShellProps = React.HTMLAttributes<HTMLDivElement>

export const HEADER_HEIGHT = 30

export const DataTableHeaderShell: React.FC<DataTableHeaderShellProps> = ({
  ...divProps
}) => {
  return <Root {...divProps} />
}

const Root = styled.div`
  display: grid;
  position: sticky;
  top: 0;
  background-color: var(--data-table-header-bg, var(--background-2));
  height: ${HEADER_HEIGHT}px;
  padding-inline: var(--data-table-header-padding-inline);
`
